import { PropsWithChildren } from "react";
import { Steps } from "../steps/steps";

export interface Step {
  title: string;
  valid?: boolean;
}

interface StepperProps {
  children: React.ReactElement<Step>[];
  desiredStepIndex: number;
}

export function Stepper({ children, desiredStepIndex }: StepperProps) {
  const nearestInvalidStepIndex = children
    .map((x) => x.props.valid)
    .indexOf(false);

  const activeStepIndex =
    nearestInvalidStepIndex === -1
      ? desiredStepIndex
      : Math.min(nearestInvalidStepIndex, desiredStepIndex);

  const activeStep = children[activeStepIndex];

  return (
    <>
      <Steps
        className="p-5 bg-card"
        activeStepIndex={activeStepIndex}
        steps={children.map((x) => x.props.title)}
      />

      {activeStep}
    </>
  );
}

export const Step = ({ children }: PropsWithChildren<Step>) => children;
